export default __webpack_public_path__ + "static/no-code-accb185d8645f77dd597d245480567fd.svg";